import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { EntityService } from 'src/app/service/entityService';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'digital-assest-service';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  userName: any ;
  request = {
    scopes: ['user.read']
  }
  queryString: any;
  urlParams: any;
  entitySourceId: any;
  source: any;
  entityType: any;
  site: any;
  userSite: any;
  appRegion: any;
  nlsLanguage :string="";
  parameters: any;
  requestAPI = {
    scopes: environment.scope
  };
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService, private entityService: EntityService,
    private route: ActivatedRoute,
    private router: Router,) {
      // Do NOT call handleRedirectObservable here — MsalRedirectComponent (in bootstrap)
      // owns that call. Calling it here races against MsalRedirectComponent and
      // consumes the auth result before the original URL can be restored.
  }
 async ngOnInit(): Promise<void> {
  await this.authService.initialize();
  
  // Account change events are now handled through inProgress$ and activeAccount$
  // ACCOUNT_ADDED and ACCOUNT_REMOVED are deprecated in MSAL v4
    
    // Save the full URL (path + query string) just before MSAL redirects to Azure AD
    // so we can restore it after the user is returned from auth.
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_START),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        sessionStorage.setItem('msal.preAuthUrl', window.location.href);
      });

    // After a successful login, navigate back to the URL the user originally requested
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((msg: EventMessage) => {
        const payload = msg.payload as AuthenticationResult;
        if (payload?.account) {
          this.authService.instance.setActiveAccount(payload.account);
        }
        const preAuthUrl = sessionStorage.getItem('msal.preAuthUrl');
        if (preAuthUrl) {
          sessionStorage.removeItem('msal.preAuthUrl');
          try {
            const target = new URL(preAuthUrl);
            // Only navigate if there is a meaningful path/query (not just root)
            const destination = target.pathname + target.search;
            if (destination && destination !== '/' && destination !== '') {
              this.router.navigateByUrl(destination);
            }
          } catch {
            // preAuthUrl was not a valid URL — ignore
          }
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })
  }
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }
  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }
  loginRedirect() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }
  loginPopup() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
      });
    }
  }
  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
    }
  }
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
